
/**
 * Does the value conform to an Australian mobile number format?
 * @param  {string}  value Phone number
 * @return {Boolean}
 */
export const isMobile = value => /\s*(^\+?61\s*4|04)/.test(value);
